export default __webpack_public_path__ + "static/media/wave.fa1afafc.svg";